/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Next_MatchInputs */

const en_read_along_next_match = /** @type {(inputs: Read_Along_Next_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next match`)
};

const es_read_along_next_match = /** @type {(inputs: Read_Along_Next_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente coincidencia`)
};

/**
* | output |
* | --- |
* | "Next match" |
*
* @param {Read_Along_Next_MatchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_next_match = /** @type {((inputs?: Read_Along_Next_MatchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Next_MatchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_next_match(inputs)
	return en_read_along_next_match(inputs)
});